import React from "react";
import styles from "./TestPage.module.css";
import CardGameType from "../../components/CardGameType.tsx";
import JokerHorizontalList from "../../components/JokerHorizontalList.tsx";
import { allGameList } from "../../util/CollectionData.tsx";

const TestPage = () => {
  return (
    <>
      {allGameList.map((item) => (
        <div
          className={styles["parent-container"]}
          style={{ margin: "50px 0px 50px 0" }}
        >
          <JokerHorizontalList
            items={item}
            isBlurEffectEnable={true}
            renderItem={(game, index, isHovered) => (
              <CardGameType
                key={index}
                title={game.text || game.title || "Default Text"}
                URL={game.URL || "#"}
                paragraph={
                  game.paragraph || game.description || "Default description"
                }
                srcImage={game.srcImage || game.urlImage || "defaultImage.jpg"}
                indicatorVideo={game.indicator}
                isHoveredIndex={isHovered}
              />
            )}
          />
        </div>
      ))}
    </>
  );
};

export default TestPage;
